import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Pagination from "react-bootstrap/Pagination";
import FormControl from "react-bootstrap/FormControl";
import InputGroup from "react-bootstrap/InputGroup";
import {
  FaSearch,
  FaPlus,
  FaPlay,
  FaEye,
  FaCloudDownloadAlt,
  FaCheck,
} from "react-icons/fa";
import FilterComponent from "../common/filter";
import DownloadExelButton from "../common/downloadExcelButton";
import { useNavigate } from "react-router-dom";
import { formatToSpanishTimeZone } from "../../utils/formatDate";
import {
  FaBackwardStep,
  FaCheckDouble,
  FaCloudArrowDown,
  FaForwardStep,
  FaPencil,
  FaToggleOff,
  FaToggleOn,
  FaTrash,
  FaClipboardUser
} from "react-icons/fa6";
import { BiCheckDouble } from "react-icons/bi";

import { DisabledUserService } from "../../Services/userService";
import { DisabledCompanyService } from "../../Services/companyService";
import { postCancelSubEnvironmentService } from "../../Services/environmentService";

import { Tooltip, OverlayTrigger, Form } from "react-bootstrap";
import MessagePopUp from "./messagePopUp";
import Spinner from "react-bootstrap/Spinner";
import { downloadDoc } from "../../utils/downloadDoc";
import { RiCheckDoubleLine } from "react-icons/ri";
import { InnuvaCompaniesModal } from "../specific/innuvaModals";
import { DisabledWorkPlaceService } from "../../Services/workPlaceService";
import { PatchNotificationViewFeedbackService } from "../../Services/notificationService";
import { DeleteSignFileService } from "../../Services/signFileService";
import { DeleteCategoryResponsiblesService } from "../../Services/categoryResponsiblesService";
import PopUpSimulateResponsibles from "../specific/popUpSimulateResponsibles";

const CustomTable = ({
  data,
  showImportButton,
  showNewButton,
  addButton,
  simulateButton,
  addClicked,
  NewButtonRoute,
  navigateTo,
  columnHeaders,
  fieldsToShow,
  optionArrays,
  excelButton,
  cardFilter,
  defaultFilterField,
  defaultFilterDirection,
  dataType,
  loading,
  onFilteredDataChange,
  doubleButton,
  editButton = true,
  deleteButton = false,
  viewButton,
  downloadButton,
  displayFilter = true,
  displaySubsButton,
  displayCheckBoxSelector,
  onSelectedItems,
  showModalFromCompany = false,
  itemsNumber,
  hideItemsNumber = false,
  innuvaCompaniesFromCompany,
  displayCompaniesCounter = false,
  companyApiResponseFromInnuvaModal,
  innuvaImportTable = false,
  workPlacesTable = false,
  feedbackTable = false,
  notificationsTable = false,
  categoryResponsiblesTable = false,
  displayPopUp,
  requiredReloadData

}) => {
  const navigate = useNavigate();
  const [t] = useTranslation("table")
  const [sortedData, setSortedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(itemsNumber ? itemsNumber : 10);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortField, setSortField] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");
  const [appliedFilters, setAppliedFilters] = useState({});
  const [showFilterOptions, setShowFilterOptions] = useState(false);
  const [showSimulateResponsibles, setShowSimulateResponsibles] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showPopup2, setShowPopup2] = useState(false);
  const [showPopup3, setShowPopup3] = useState(false);
  const [showPopup4, setShowPopup4] = useState(false);
  const [showPopup5, setShowPopup5] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [showDisableWorkplaceWarning, setShowDisableWorkplaceWarning] = useState(false);
  const [showModalImport, setShowModalImport] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [currentCompany, setCurrentCompany] = useState(null);
  const [workPlace, setCurrentWorkPlace] = useState(null);
  const [errorWorkplace, setErrorWorkplace] = useState(null);
  const [popupMessage, setPopupMessage] = useState({ title: "", body: "" });
  const lastDataRef = useRef(); //variable para no enviar datos repetidos y provocar un bucle infinito.
  const [selected, setSelected] = useState([]); //Initial state for selected items

  const handleButtonMessagePopUpClick = () => {

    setShowPopup(false);
    setShowModal(true);

    if (dataType === "workPlaces") {
      let messageTitle = "";
      let messageBody = "";

      if (!workPlace?.workplaceEnabled && !errorWorkplace) { //como viene el estado anterior si viene enabbled es que se ha deshabilitado
        messageTitle = `${t("table.enableWorkplaceWarningTitle")}`;
        messageBody = `${t("table.enableWorkplaceWarningText")}`;
        setPopupMessage({ title: messageTitle, body: messageBody });
        setShowDisableWorkplaceWarning(true);
      } else {

        requiredReloadData();
      }



    } else {

      window.location.reload();
    }

  };

  const handleDisableWorkplaceWarning = () => {
    setShowDisableWorkplaceWarning(false);
    requiredReloadData();
  }


  const handleViewNotificationFeedback = (feedbackId) => async () => {
    await PatchNotificationViewFeedbackService(feedbackId);
    requiredReloadData()
  }

  const handleOnClickDelete = (item) => () => {
    const firstPropertyKey = Object.keys(item)[0];
    const firstPropertyValue = item[firstPropertyKey];

    let messageTitle = "";
    let messageBody = "";

    if (dataType === "signFiles") {
      messageTitle = `${t("table.deleteSignFilesTitle")}`
      messageBody = `${t("table.deleteSignFilesText")}: <b>${item.fileName}</b>`;
    }

    if (dataType === "categoryResponsibles") {
      messageTitle = `${t("table.deleteCategoryResponsiblesTitle")}`
      messageBody = `${t("table.deleteCategoryResponsiblesText")}: <br>${t("table.deleteCategoryResponsiblesTextCategory")} - <b>${item.categoryName}</b> <br>${item.workplaceName ? `${t("table.deleteCategoryResponsiblesTextWorkPlace")} - <b>${item.workplaceName}</b> <br>` : ''} ${t("table.deleteCategoryResponsiblesTextResponsible")} - <b>${item.responsibleFullNameNIF}</b><br><br>${t("table.deleteCategoryResponsiblesTextReminder")}`;
    }

    setPopupMessage({ title: messageTitle, body: messageBody, item: item });
    setShowPopup5(true)
  };



  const handleOnClickToggleEnable = (item) => () => {
    const firstPropertyKey = Object.keys(item)[0];
    const firstPropertyValue = item[firstPropertyKey];

    let messageTitle = "";
    let messageBody = "";

    if (dataType === "companies") {
      messageTitle = !item.enabled
        ? `${t("table.companyEnabledTitle")}`
        : `${t("table.companyDisabledTitle")}`;
      messageBody = `${!item.enabled ? `${t("table.companyEnabledText")}` : `${t("table.companyDisabledText")}`
        } ${t("table.companyText")}: ${item.name} (${item.nifCif})`;
      disableCompany(item, firstPropertyValue);
    } else if (dataType === "users") {
      messageTitle = !item.enabled
        ? `${t("table.userEnabledTitle")}`
        : `${t("table.userDisabledTitle")}`;
      messageBody = `${!item.enabled ? `${t("table.userEnabledText")}` : `${t("table.userDisabledText")}`
        } ${t("table.userText")}: ${item.name} ${item.surname} (${item.nif})`;
      disableUser(item, firstPropertyValue);
    }

    setPopupMessage({ title: messageTitle, body: messageBody });
  };

  const handleOnClickToggleWorkPlaceEnable = (item) => () => {

    const firstPropertyKey = Object.keys(item)[0];
    const firstPropertyValue = item[firstPropertyKey];

    let messageTitle = "";
    let messageBody = "";

    if (dataType === "workPlaces") {
      messageTitle = !item.workplaceEnabled
        ? `${t("table.workplaceEnabledTitle")}`
        : `${t("table.workplaceDisabledTitle")}`;
      messageBody = `${!item.workplaceEnabled ? `${t("table.workplaceEnabledText")}` : `${t("table.workplaceDisabledText")}`
        } ${t("table.workplaceText")}: ${item.workplaceName}`;
      disableWorkPlace(item, firstPropertyValue);
    }

    setPopupMessage({ title: messageTitle, body: messageBody });
  };

  const handleCancelSub = async () => {
    const responseCancel = await postCancelSubEnvironmentService();

    if (responseCancel.succes) {
      setShowPopup4(true);
    }
  };
  const handleDeleteConfirmClick = async (item) => {
    setLoadingDelete(true);
    if (dataType === 'signFiles') {

      const response = await DeleteSignFileService(item.signFile);
    }

    if (dataType === 'categoryResponsibles') {
      const response = await DeleteCategoryResponsiblesService(item.categoryResponsibleId);
    }
    setLoadingDelete(false);
    setShowPopup5(false);
    requiredReloadData();

  };

  const onFilterChange = (selectedOptions) => {
    setAppliedFilters(selectedOptions);
  };

  const handleNewClick = () => {
    // Acción para el botón de "Nuevo"
    navigate(NewButtonRoute);
    // Aquí puedes agregar lógica adicional, como navegar a una nueva página
  };

  const handleAddClick = (e) => {
    addClicked(e)
  };

  const handleImportClick = () => {
    setShowModalImport(true);
  };

  const handleSimulateClick = () => {
    setShowSimulateResponsibles(true);
  };

  const navigateToPage = (id, data) => {
    navigate(`${navigateTo}/${id}`, { state: { data } });
  };


  const disableUser = async (user, idUser) => {
    var response = await DisabledUserService(user, idUser);

    if (response.msg) {
      setShowPopup2(true);
    } else {
      setCurrentUser(user);
      setShowPopup(true);
    }
  };

  const disableCompany = async (company, idCompany) => {
    await DisabledCompanyService(company, idCompany);
    setCurrentCompany(company);
    setShowPopup(true);
  };

  const disableWorkPlace = async (workPlace, idWorkPlace) => {
    let result = await DisabledWorkPlaceService(workPlace, idWorkPlace);
    if (result.success === false) {
      setPopupMessage({ title: result.title, body: result.message })
      setErrorWorkplace(true)
    } else {
      setCurrentWorkPlace(workPlace);
      setShowPopup(true);
      setErrorWorkplace(false)
    }
    setShowPopup(true);
  };

  const renderTooltipEdit = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {t("table.edit")}
    </Tooltip>
  );

  const renderTooltipCheck = (props) => (

    <Tooltip id="button-tooltip" {...props}>
      {t("table.check")}
    </Tooltip >
  );

  const renderTooltipView = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {t("table.view")}
    </Tooltip>
  );

  const renderTooltipDownload = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {t("table.download")}
    </Tooltip>
  );

  const renderTooltipDelete = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {t("table.delete")}
    </Tooltip>
  );

  const renderTooltipEnable = (isEnabled) => (props) =>
  (
    <Tooltip id="button-tooltip" {...props}>
      {isEnabled ? `${t("table.disable")}` : `${t("table.enable")}`}
    </Tooltip>
  );

  useEffect(() => {

    if (data && data.length > 0) {
      setSortedData(data);
    }


  }, [data]);

  useEffect(() => {
    if (defaultFilterField && defaultFilterDirection) {
      sortData(
        defaultFilterField,
        defaultFilterDirection === "asc" ? "desc" : "asc"
      );
    }
  }, [data]);

  const sortData = (field, sortDirection) => {
    let direction = sortDirection;
    if (sortField === field) {
      direction = direction === "asc" ? "desc" : "asc";
    }

    const sorted = [...data].sort((a, b) => {
      if (!a.hasOwnProperty(field) || !b.hasOwnProperty(field)) return 0;

      // Comprobar si el campo es una fecha y compararla
      if (field === "createdAt" || field === "updatedAt" || isValidDate(a[field])) {
        const dateA = parseCustomDate(a[field]);
        const dateB = parseCustomDate(b[field]);
        return direction === "asc" ? dateA - dateB : dateB - dateA;
      }

      // Extraer y comparar el número si el campo es "incidentKey"
      if (field === "incidentKey") {
        const numA = parseInt(a[field].split("-").pop());
        const numB = parseInt(b[field].split("-").pop());

        return direction === "asc" ? numA - numB : numB - numA;
      }

      if (a[field] > b[field]) return direction === "asc" ? 1 : -1;
      if (a[field] < b[field]) return direction === "asc" ? -1 : 1;
      return 0;
    });

    setSortedData(sorted);
    setSortField(field);
    setSortDirection(direction);
  };

  const isValidDate = (date) => {
    const parsedDate = parseCustomDate(date);
    return !isNaN(parsedDate.getTime());
  };

  // Función para convertir fechas en formato 'dd/MM/yyyy' a un objeto Date válido
  const parseCustomDate = (dateString) => {
    if (typeof dateString === 'string' && dateString.includes('/')) {
      const [day, month, year] = dateString.split('/');
      return new Date(`${year}-${month}-${day}T00:00:00`); // Formato ISO válido
    }
    return new Date(dateString); // Para otros formatos que JavaScript ya maneja
  };

  const handleDisplayFilters = (e) => {
    setShowFilterOptions(!showFilterOptions);
  };

  const handleChangeSearch = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
  };

  const filteredData = sortedData.filter((item) => {
    // Filtrar según el término de búsqueda (insensible a mayúsculas y minúsculas)
    const matchesSearch = Object.values(item).some((val) =>
      val
        ? val.toString().toLowerCase().includes(searchTerm.toLowerCase())
        : false
    );


    // Filtrar según los filtros aplicados
    const matchesFilters = Object.keys(appliedFilters).every((key) => {

      if (item.hasOwnProperty(key)) {
        const itemValue = item[key] ? item[key].toString().toLowerCase() : '';
        const filterValue =
          appliedFilters[key] === `${t("table.enabled")}`
            ? true
            : appliedFilters[key] === `${t("table.disabled")}`
              ? false
              : appliedFilters[key]
                ? appliedFilters[key].toLowerCase()
                : "";
        return itemValue.includes(filterValue);
      }
    });

    return matchesSearch && matchesFilters;
  });

  const handleResetFilters = () => {
    // Puedes reiniciar los filtros o realizar cualquier acción necesaria
    // Por ejemplo, aquí reiniciamos los filtros a un objeto vacío
    setAppliedFilters({});
  };

  const handleCaseCardClick = (filterField, filterValue) => {
    setAppliedFilters({
      [filterField]: filterValue,
    });
  };

  useEffect(() => {
    if (cardFilter) {
      handleCaseCardClick(cardFilter.field, cardFilter.value);
    } else {
      // Aquí debes manejar el caso en que se debe mostrar todos los registros
      // Por ejemplo, reestableciendo los filtros a su estado inicial
      setAppliedFilters({});
    }
  }, [cardFilter]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const handleButtonMessageErrorLoginClick = () => {
    setShowPopup2(false);
    setShowModal2(true);
  };

  const handleButtonMessageErrorCancelSubClick = () => {
    setShowPopup4(false);
    window.location.reload();
  };

  const handleButtonMessageErrorNotAvailableClick = () => {
    setShowPopup3(false);
  };

  //Enviamos los datos filtrados a incidentMain para que el resumen refleje dichos datos filtrados.
  //También con lastDataRef nos aseguramos de evitar bucles infinitos.
  useEffect(() => {
    if (onFilteredDataChange) {
      if (
        JSON.stringify(filteredData) !== JSON.stringify(lastDataRef.current)
      ) {
        onFilteredDataChange(filteredData);
        lastDataRef.current = filteredData;
      }
    }
  }, [filteredData]);

  /*  Handlers para el comportamiento de CheckBox de la tabla. */

  const handleSelectAll = (e) => {
    if (displayCheckBoxSelector) {
      const newSelection = e.target.checked ? [...filteredData] : [];
      setSelected(newSelection);
    }
  };

  const handleSelect = (item) => {
    if (displayCheckBoxSelector) {
      const selectedIndex = selected.findIndex(
        (selectedItem) =>
          Object.entries(selectedItem).toString() ===
          Object.entries(item).toString()
      );

      let newSelected = [];
      if (selectedIndex === -1) {
        newSelected = [...selected, item];
      } else {
        newSelected = [...selected];
        newSelected.splice(selectedIndex, 1);
      }
      setSelected(newSelected);
    }
  };

  useEffect(() => {
    if (selected.length > 0) {
      onSelectedItems?.(selected);
    } else {
      onSelectedItems?.([]);
    }
  }, [selected]);

  useEffect(() => {
    setShowModalImport(showModalFromCompany);
  }, [showModalFromCompany]);



  return (
    <div className="w-100">
      <MessagePopUp
        show={showPopup}
        handleClose={() => setShowPopup(false)}
        title={popupMessage.title}
        textBody={popupMessage.body}
        buttonText={t("table.acceptButton")}
        onClickButton={handleButtonMessagePopUpClick}
      />

      <MessagePopUp
        show={showPopup2}
        handleClose={() => setShowPopup2(false)}
        title={t("table.messageCantDisableTitle")}
        textBody={t("table.messageCantDisableText")}
        buttonText={t("table.acceptButton")}
        onClickButton={handleButtonMessageErrorLoginClick}
      />

      <MessagePopUp
        show={showPopup3}
        handleClose={() => setShowPopup3(false)}
        title={t("table.messageNotAvailableTitle")}
        textBody={t("table.messageNotAvailableText")}
        buttonText={t("table.acceptButton")}
        onClickButton={handleButtonMessageErrorNotAvailableClick}
      />

      <MessagePopUp
        show={showPopup4}
        handleClose={() => setShowPopup4(false)}
        title={t("table.messageLeaveTitle")}
        textBody={t("table.messageLeaveText")}
        buttonText={t("table.acceptButton")}
        onClickButton={handleButtonMessageErrorCancelSubClick}
      />

      <MessagePopUp
        show={showPopup5}
        handleClose={() => setShowPopup5(false)}
        title={popupMessage.title}
        textBody={popupMessage.body}
        buttonText={t("table.confirmButton")}
        cancelButtonText={t("table.cancelButton")}
        onClickCancelButton={() => setShowPopup5(false)}
        onClickButton={() => handleDeleteConfirmClick(popupMessage.item)}
        loading={loadingDelete}
      />

      <MessagePopUp
        show={showDisableWorkplaceWarning}
        handleClose={handleDisableWorkplaceWarning}
        title={popupMessage.title}
        textBody={popupMessage.body}
        buttonText={t("table.confirmButton")}
        onClickButton={handleDisableWorkplaceWarning}
      />

      <InnuvaCompaniesModal
        show={showModalImport}
        handleClose={() => {
          setShowModalImport(false);
        }}
        onClickButton={handleImportClick}
        companiesFromInnuva={innuvaCompaniesFromCompany}
        companyApiResponseFromInnuvaModal={companyApiResponseFromInnuvaModal}
      />

      <PopUpSimulateResponsibles
        show={showSimulateResponsibles}
        handleClose={() => setShowSimulateResponsibles(false)}
        companyList={data}
      />

      <div className="table-toolbar">
        {simulateButton && (
          <Button
            className="mb-3 mt-3 new-button background-gradient custom-shadow"
            onClick={handleSimulateClick}
          >
            <FaClipboardUser /> <span className="new-button-text">{t("table.simulate")}</span>
          </Button>
        )}

        {showImportButton && (
          <Button
            className="mb-3 mt-3 new-button background-gradient custom-shadow"
            onClick={handleImportClick}
          >
            <FaCloudArrowDown />{" "}
            <span className="new-button-text">{t("table.import")}</span>
          </Button>
        )}

        {showNewButton && (
          <Button
            className="mb-3 mt-3 new-button background-gradient custom-shadow"
            onClick={handleNewClick}
          >
            <FaPlus /> <span className="new-button-text">{t("table.new")}</span>
          </Button>
        )}

        {addButton && (
          <Button
            className="mb-3 mt-3 new-button background-gradient custom-shadow"
            onClick={handleAddClick}
          >
            <FaPlus /> <span className="new-button-text">{t("table.add")}</span>
          </Button>
        )}


        {excelButton && (
          <DownloadExelButton
            columnHeaders={columnHeaders}
            fieldsToShow={fieldsToShow}
            incidentDataOnly={currentItems}
          />
        )}

        {/* InputGroup para filtrar */}
        {displayFilter ? (
          <InputGroup
            className="mb-3 mt-3 custom-shadow"
            style={{ width: "fit-content" }}
          >
            <InputGroup.Text
              className="toolbar-button"
              onClick={handleDisplayFilters}
            >
              <FilterComponent
                onFilterChange={onFilterChange}
                onResetFilters={handleResetFilters}
                columnHeaders={columnHeaders}
                fieldsToShow={fieldsToShow}
                optionArrays={optionArrays}
                showFilterOptions={showFilterOptions}
                toggleShowFilter={handleDisplayFilters}
              />
            </InputGroup.Text>
          </InputGroup>
        ) : null}

        {/* InputGroup para buscar */}
        <InputGroup className="mb-3 mt-3" style={{ width: "300px" }}>
          <InputGroup.Text className="toolbar-button">
            <FaSearch />
          </InputGroup.Text>
          <FormControl
            placeholder={t("table.searchPlaceholder")}
            onChange={handleChangeSearch}
            className="toolbar-button-search"
          />
        </InputGroup>
      </div>

      <Table className="custom-shadow full-width-scroll" striped hover check >
        <thead className="table-head">
          <tr>
            {displayCheckBoxSelector ?
              (
                <th className="table-head-item">
                  <Form.Check
                    type="checkbox"
                    onChange={handleSelectAll}
                    checked={selected.length === filteredData.length && filteredData.length > 0}
                    indeterminate={selected.length > 0 && selected.length < filteredData.length}
                  />
                </th>
              )
              :
              null
            }

            {fieldsToShow.map((field, index) => (
              <th
                className="table-head-item"
                key={index}
                onClick={() => sortData(field, sortDirection)}
              >
                {columnHeaders[index].toUpperCase()}
                {sortField === field &&
                  (sortDirection === "asc" ? (
                    <span>&uarr;</span>
                  ) : (
                    <span>&darr;</span>
                  ))}
              </th>
            ))}
            {viewButton || deleteButton || editButton || downloadButton || displaySubsButton ? <th className="table-head-item"></th> : null}
            {/* Columna sin encabezado para el botón de editar */}
          </tr>
        </thead>

        {loading ? (
          <div className="table-loading-container">
            <div className="table-loading-row ">
              <div className="table-loading-popup custom-shadow-bold rounded-border-px">
                <Spinner animation="border" className="spinner-big" />
              </div>
            </div>
          </div>
        ) : null}

        {filteredData.length > 0 ? (
          <tbody className="align-middle">
            {currentItems.map((item, index) => (
              <tr key={index} className={`${item.remainingDays <= 7 && item.remainingDays ? 'table-danger table-alert-register' : ''}`}>
                {displayCheckBoxSelector ? (
                  <td className="width-5" >
                    <Form.Check
                      type="checkbox"
                      checked={selected.some(
                        (selectedItem) =>
                          Object.entries(selectedItem).toString() ===
                          Object.entries(item).toString()
                      )}
                      onChange={() => handleSelect(item)}
                    />
                  </td>
                ) : null}

                {fieldsToShow.map((field, idx) => (

                  <td className={`${workPlacesTable ? field === 'workplaceEnabled' ? 'width-20' : 'width-35' : ''} ${feedbackTable && field === 'title' ? 'width-65' : ''} ${innuvaImportTable ? field === 'name' ? 'width-65' : 'width-30' : field === 'nifCif' ? 'width-30' : ''} ${categoryResponsiblesTable && 'width-30'}`} key={idx}>
                    {field === "enabled"
                      ? item[field]
                        ? `${t("table.enabled")}`
                        : `${t("table.disabled")}`
                      : field === "createdAt"
                        ? item[field]
                        : item[field]}
                    {field === "enabledSubscription"
                      ? item[field]
                        ? `${t("table.active")}`
                        : `${t("table.requestedLeave")}`
                      : null}
                    {field === 'workplaceEnabled'
                      ? item[field]
                        ? `${t("table.enabled")}`
                        : `${t("table.disabled")}`
                      : null}

                  </td>
                ))}
                <td style={{ width: doubleButton ? "8vw" : "4vw", display: deleteButton || editButton || viewButton || downloadButton || displaySubsButton ? "" : "none" }}>
                  {editButton || viewButton ? (
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 250, hide: 250 }}
                      overlay={
                        viewButton ? item.feedback ? renderTooltipCheck : renderTooltipView : renderTooltipEdit
                      }
                    >
                      <Button
                        className="custom-shadow-bold edit-button"
                        onClick={() => {
                          const firstPropertyKey = Object.keys(item)[0];
                          const firstPropertyValue = item[firstPropertyKey];

                          if (workPlacesTable || feedbackTable || categoryResponsiblesTable) {
                            displayPopUp(item);
                          } else if (item.feedback) {
                            //no quitar parentesis final
                            handleViewNotificationFeedback(item.notification)();
                          } else {
                            navigateToPage(firstPropertyValue, item);
                          }
                        }}
                        disabled={item.feedback && item.viewBool}
                      >
                        {viewButton ? item.feedback && notificationsTable ? item.viewBool ? <RiCheckDoubleLine /> : <FaCheck /> : <FaEye /> : <FaPencil />}
                      </Button>
                    </OverlayTrigger>
                  ) : null}

                  {downloadButton ? (
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 250, hide: 250 }}
                      overlay={renderTooltipDownload}
                    >
                      <Button
                        className="custom-shadow-bold edit-button"
                        onClick={() => {
                          downloadDoc(
                            item.fileMimeType,
                            item.fileData,
                            item.incidentKey,
                            item.fileName
                          );
                        }}
                      >
                        <FaCloudDownloadAlt />
                      </Button>
                    </OverlayTrigger>
                  ) : null}

                  {deleteButton ? (
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 250, hide: 250 }}
                      overlay={renderTooltipDelete}
                    >
                      <Button
                        className="custom-shadow-bold delete-button me-0"
                        onClick={handleOnClickDelete(item)}
                      >
                        <FaTrash />
                      </Button>
                    </OverlayTrigger>
                  ) : null}

                  {typeof item.enabled !== "undefined" && (
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 250, hide: 250 }}
                      overlay={renderTooltipEnable(item.enabled)}
                    >
                      {item.enabled ? (
                        <Button
                          onClick={handleOnClickToggleEnable(item)}
                          className="custom-shadow-bold enable-button"
                        >
                          <FaToggleOn size={25} />
                        </Button>
                      ) : (
                        <Button
                          onClick={handleOnClickToggleEnable(item)}
                          className="custom-shadow-bold disable-button"
                        >
                          <FaToggleOff size={25} onClick={() => { }} />
                        </Button>
                      )}
                    </OverlayTrigger>
                  )}

                  {typeof item.workplaceEnabled !== "undefined" && (
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 250, hide: 250 }}
                      overlay={renderTooltipEnable(item.workplaceEnabled)}
                    >
                      {item.workplaceEnabled ? (
                        <Button
                          onClick={handleOnClickToggleWorkPlaceEnable(item)}
                          className="custom-shadow-bold enable-button"
                        >
                          <FaToggleOn size={25} />
                        </Button>
                      ) : (
                        <Button
                          onClick={handleOnClickToggleWorkPlaceEnable(item)}
                          className="custom-shadow-bold disable-button"
                        >
                          <FaToggleOff size={25} onClick={() => { }} />
                        </Button>
                      )}
                    </OverlayTrigger>
                  )}



                  {displaySubsButton ? (
                    item.enabledSubscription ? (
                      <Button
                        onClick={handleCancelSub}
                        className="custom-shadow-bold enable-button fs-8"
                      >
                        {t("table.requestLeave")}
                      </Button>
                    ) : null
                  ) : // <Button
                    //   //onClick={handleOnClickToggleEnable(item)}
                    //   className="custom-shadow-bold disable-button">
                    //   RENOVAR
                    // </Button>
                    null}
                </td>

              </tr>
            ))}
          </tbody>) : !loading ?
          <tbody>
            <tr>
              <td
                colSpan={fieldsToShow.length + 1}
                style={{ textAlign: "center" }}
              >
                <p>{t("table.noData")}</p>
              </td>
            </tr>
          </tbody>

          :
          null}
      </Table>

      <div className="justify-content-end table-footer">
        {displayCompaniesCounter
          ?
          <div className="display-company-container">
            <span className="display-company-text">{t("table.selected")} <b>{selected.length}</b> {t("table.of")} {filteredData.length} {t("table.companies")}</span>
          </div>
          : null
        }
        {!hideItemsNumber ?
          <div className="margin-right-1">
            {t("table.show")}
            <select
              className="select-num-items"
              value={itemsPerPage}
              onChange={(e) => setItemsPerPage(parseInt(e.target.value))}
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={20}>20</option>
            </select>
          </div>
          :
          null
        }


        <Pagination className="custom-pagination">
          <Pagination.First
            className="custom-pagination-buttons"
            onClick={() => setCurrentPage(1)}
          >
            <FaBackwardStep className="color-custom-primary" />
          </Pagination.First>

          <Pagination.Prev
            className="custom-pagination-buttons"
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          >
            <FaPlay
              className="color-custom-primary rotate-clockwise"
              size={12}
            />
          </Pagination.Prev>

          <Pagination.Item className="custom-shadow-bold" disabled>
            {t("table.page")}{" "}
            <span className="color-custom-primary">
              <strong>{currentPage}</strong>
            </span>{" "}
            {t("table.of")}{" "}
            <span>
              <strong> {Math.ceil(filteredData.length / itemsPerPage)}</strong>
            </span>
          </Pagination.Item>

          <Pagination.Next
            className="custom-pagination-text"
            onClick={() =>
              setCurrentPage((prev) =>
                Math.min(
                  prev + 1,
                  Math.ceil(filteredData.length / itemsPerPage)
                )
              )
            }
          >
            <FaPlay className="color-custom-primary" size={12} />
          </Pagination.Next>

          <Pagination.Last
            className="custom-pagination-buttons"
            onClick={() =>
              setCurrentPage(Math.ceil(filteredData.length / itemsPerPage))
            }
          >
            <FaForwardStep className="color-custom-primary" />
          </Pagination.Last>
        </Pagination>
      </div>
    </div>
  );
};

export default CustomTable;
